import _ from 'lodash';

export default {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    isMobileOrTablet() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isDesktop() {
      return !this.isMobileOrTablet;
    },
    /**
     * Accepts an object of classes for corresponding breakpoints.
     * Will return the lowest matching breakpoint's classes.
     */
    responsiveClasses() {
      return ({ mobile, desktop = '', tablet }) => {
        if (_.isString(mobile) && this.isMobile) return mobile;
        if (_.isString(tablet) && this.isMobileOrTablet) return tablet;
        return desktop;
      };
    },
  },
};
